import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import Layout from '../components/layout/Layout';

const API = process.env.REACT_APP_BACKEND_URL;

export default function IntakeFormPage() {
  const { slug } = useParams();
  const [form, setForm] = useState(null);
  const [answers, setAnswers] = useState({});
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { axios.get(`${API}/api/intake-forms/${slug}`).then(r=>setForm(r.data)).catch(()=>setForm(false)); }, [slug]);
  if (form === null) return <Layout><div className="max-w-2xl mx-auto p-8 text-center text-[#94A3B8]">Loading...</div></Layout>;
  if (form === false) return <Layout><div className="max-w-2xl mx-auto p-8 lg:p-12 text-center"><h1 className="text-2xl font-bold text-[#0A0F1C] mb-2">No intake form here</h1><p className="text-[#475569] mb-6">This link doesn't point to a specific intake form. If you were sent an intake link, please use the exact link from your email or message.</p><a href="/" className="btn-primary-orange text-sm inline-block">Back to home</a></div></Layout>;
  const upd = (k, v) => setAnswers({ ...answers, [k]: v });
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const r = await axios.post(`${API}/api/intake-forms/${slug}/submit`, { answers }); setDone(r.data.success_message || 'Thanks!'); }
    catch (e) { toast.error(e.response?.data?.detail||'Failed'); } finally { setBusy(false); }
  };
  if (done) return <Layout><div className="max-w-2xl mx-auto p-8 text-center"><h1 className="text-3xl font-bold text-[#0A0F1C] mb-3">Thank you</h1><p className="text-[#475569]">{done}</p></div></Layout>;
  return (<Layout title={form.name}>
    <div className="max-w-2xl mx-auto p-6 lg:p-12">
      <h1 className="text-3xl font-bold text-[#0A0F1C] mb-2" data-testid="intake-title">{form.name}</h1>
      {form.description && <p className="text-[#475569] mb-6">{form.description}</p>}
      <form onSubmit={submit} className="space-y-4 bg-white border border-[#E2E8F0] rounded-xl p-6" data-testid="intake-form">
        {(form.fields||[]).map(f => (
          <label key={f.key} className="block">
            <span className="text-sm font-bold text-[#0A0F1C] block mb-1">{f.label}{f.required && <span className="text-red-600 ml-1">*</span>}</span>
            {f.type === 'textarea' ? (
              <textarea required={f.required} rows={4} value={answers[f.key]||''} onChange={e=>upd(f.key,e.target.value)} className="w-full px-3 py-2 border border-[#E2E8F0] rounded text-sm" data-testid={`if-${f.key}`}/>
            ) : f.type === 'select' ? (
              <select required={f.required} value={answers[f.key]||''} onChange={e=>upd(f.key,e.target.value)} className="w-full px-3 py-2 border border-[#E2E8F0] rounded text-sm" data-testid={`if-${f.key}`}><option value="">Select...</option>{(f.options||[]).map(o=><option key={o} value={o}>{o}</option>)}</select>
            ) : f.type === 'checkbox' ? (
              <input type="checkbox" checked={!!answers[f.key]} onChange={e=>upd(f.key,e.target.checked)} data-testid={`if-${f.key}`}/>
            ) : (
              <input type={f.type==='phone'?'tel':f.type} required={f.required} value={answers[f.key]||''} onChange={e=>upd(f.key,e.target.value)} className="w-full px-3 py-2 border border-[#E2E8F0] rounded text-sm" data-testid={`if-${f.key}`}/>
            )}
          </label>
        ))}
        <button type="submit" disabled={busy} className="btn-primary-orange text-sm w-full" data-testid="if-submit">{busy?'Submitting...':(form.submit_button_text||'Submit')}</button>
      </form>
    </div>
  </Layout>);
}
